import {
  TournamentsQueryParams,
  TournamentsResponse,
} from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const initGameDetails = createAction(
  '[GameDetails Page] Init',
  props<{ params: TournamentsQueryParams }>(),
);

export const loadGameDetailsSuccess = createAction(
  '[GameDetails/API Page] Load GameDetails Success',
  props<{
    cashTournaments: TournamentsResponse;
    prizeTournaments: TournamentsResponse;
  }>(),
);

export const loadGameDetailsFailure = createAction(
  '[GameDetails/API Page] Load GameDetails Failure',
  props<{ error: any }>(),
);

export const loadMoreGameDetails = createAction(
  '[GameDetails Page] Load More Game Details',
  props<{ params: TournamentsQueryParams }>(),
);

export const loadMoreGameDetailsSuccess = createAction(
  '[GameDetails/API Page] Load More GameDetails Success',
  props<{
    cashTournaments: TournamentsResponse;
    prizeTournaments: TournamentsResponse;
  }>(),
);

export const loadMoreGameDetailsFailure = createAction(
  '[GameDetails/API Page] Load More GameDetails Failure',
  props<{ error: any }>(),
);

export const filterGameDetails = createAction(
  '[GameDetails/API Page] Filter Game',
  props<{ params: TournamentsQueryParams }>(),
);

export const filterGameDetailsSuccess = createAction(
  '[GameDetails/API Page] Filter Game Details Success',
  props<{
    cashTournaments: TournamentsResponse;
    prizeTournaments: TournamentsResponse;
  }>(),
);

export const filterGameDetailsFailure = createAction(
  '[GameDetails/API Page] Filter Game Details Failure',
  props<{ error: string }>(),
);

export const clearFilterGameDetailsByTag = createAction(
  '[GameDetails/API Page] Clear Game Details Filter By Tag',
);

export const clearSearchGameDetails = createAction(
  '[GameDetails/API] Clear Search Games Details',
);

export const clearRoomFilters = createAction(
  '[GameDetails/API Page] Clear Filters',
);


export const restoreGameDetails = createAction(
  '[GameDetails/API Page] Load Game Details',
  props<{ payload: any }>(),
);

export const storedGameDetails = createAction(
  '[GameDetails/API Page] Store Game Details'
);